<template>
  <div class="header">
    <div class="left">
      <!-- <img src="@/assets/logo-1.png" alt="" /> -->
      一体机订单管理后台
      <span class="nav-box">
        <span
          class="nav-item"
          :class="{'activeSection': $route.name === 'home'}"
          @click="$router.push('/home')">
          订单查询
        </span>
        <span
          class="nav-item"
          :class="{'activeSection': $route.name === 'dataSearch'}"
          @click="$router.push('/dataSearch')">
          数据查询
        </span>
        <span
          class="nav-item"
          :class="{'activeSection': $route.name === 'picture'}"
          @click="$router.push('/picture')">
          图片查询
        </span>
      </span>
    </div>
    <div class="right">
      <span
        @click="$router.push('/login')"
        style="margin-right: 16px; cursor: pointer"
        >{{ cname }}</span
      >
      <a-dropdown>
        <a href="#" style="color: white">
          {{ accname }}
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay" @click="handleLogout">
          <a-menu-item key="/login">
            <span>退出登陆</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    /*
    html: {
      // required: true,
      default: ''
    }
    */
  },
  data() {
    return {
      cname: '',
      accname: '',
    };
  },
  watch: {
    /*
    html (newValue) {
      // console.log(newValue)
      this.htmlVaule = newValue
    }
    */
  },
  computed: {
    /*
    readState () {
      return this.moduleType === 'detail'
    }
    */
  },
  created() {},
  mounted() {
    this.cname = this.getCname()
    this.accname = this.getAccname()
  },
  methods: {
    getAccname () {
      return localStorage.getItem('usename')
    },
    getCname () {
      try {
        const cid = localStorage.getItem('customerCode')
        const clist = JSON.parse(localStorage.getItem('cusList'))
        if (Array.isArray(clist)) {
          return clist.filter(i => i.cid == cid)[0].cname
        } else {
          return ''
        }
      } catch (e) {
        console.log(e)
      }
    },
    async handleLogout () {
      localStorage.removeItem('usename')
      localStorage.removeItem('cusList')
      localStorage.removeItem('customerCode')
      this.clearAllCookie()
      this.$router.push('/login')
    },
    clearAllCookie () {
      // eslint-disable-next-line
      const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (let i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
    },
  },
  destroyed() {},
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding-left: 20px;
  height: 60px;
  line-height: 60px;
  background-color: #414042;
  color: white;
  font-size: 18px;
  .right {
    margin-right: 20px;
  }
}
.nav-box {
  margin-left: 50px;
  .nav-item {
    color: rgba(255, 255, 255, 0.45);
    margin-right: 30px;
    cursor: pointer;
  }
  .activeSection.nav-item {
    color: white;
  }
}
</style>
